import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import copy from 'copy-to-clipboard';

import {
  Detail,
  Icon,
  Input,
  LoadingBar,
  Tooltip,
  Button,
} from 'components/common';
import useStreamValue from '../hooks/useStreamValue';

const Container = styled(Detail)`
  position: relative;
  .loader {
    position: absolute;
    top: 18px;
    left: 1px;
    width: calc(100% - 2px);
    height: calc(100% - 19px);
    display: flex;
    align-items: center;
    z-index: 2;
    background-color: #fff;
    padding-left: 10px;
  }
`;

const InputWrapper = styled.div`
  position: relative;
`;

const ButtonContainer = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
`;

const CopyButton = styled(Button)`
  background: transparent;
  border: none;
  padding: 8px;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: transparent;
    svg {
      color: #40a9ff;
    }
  }
  &:disabled {
    background: transparent;
    svg {
      color: #d9d9d9;
    }
  }
`;

function Subject({ subject, loading, style, shouldStream, disabled }) {
  const [copied, setCopied] = useState(false);
  const handleCopy = e => {
    copy(subject);
    setCopied(true);
  };

  const handleTooltipOpen = visible => {
    if (visible) {
      setCopied(false);
    }
  };

  const [streamedValue, isStreaming] = useStreamValue(subject, shouldStream);

  return (
    <Container label='Subject' style={style}>
      <InputWrapper>
        <Input
          readOnly
          value={streamedValue}
          disabled={disabled}
          style={{ paddingRight: '36px' }}
        />

        <ButtonContainer>
          <Tooltip
            title={!streamedValue ? '' : copied ? 'Copied' : 'Copy subject'}
            onOpenChange={handleTooltipOpen}
            placement='left'
            mouseLeaveDelay={0}
          >
            <CopyButton
              type='link'
              disabled={disabled || isStreaming || loading}
              onClick={() => {
                if (!loading && !disabled && !isStreaming) {
                  handleCopy();
                }
              }}
            >
              <Icon
                icon='copy'
                color={
                  disabled || isStreaming || loading ? '#d9d9d9' : '#595959'
                }
                size='sm'
                style={{ fontSize: '16px' }}
              />
            </CopyButton>
          </Tooltip>
        </ButtonContainer>
      </InputWrapper>

      {loading && (
        <div
          className='loader'
          style={{
            position: 'absolute',
            top: '18px',
            left: '1px',
            width: 'calc(100% - 2px)',
            height: '30px',
            zIndex: 1,
          }}
        >
          <LoadingBar width={389} height={18} />
        </div>
      )}
    </Container>
  );
}

Subject.propTypes = {
  style: PropTypes.shape({}),
  subject: PropTypes.string,
  loading: PropTypes.bool,
  shouldStream: PropTypes.bool,
};

export default Subject;
